import TagManager from "react-gtm-module"
import * as amplitude from "@amplitude/analytics-node"

import { get } from "tiny-cookie"

let analyticsInitialized = false

const tagManagerArgs = {
  gtmId: import.meta.env.PUBLIC_GTM_CODE,
}

function ignoreAnalytics(): boolean {
  return typeof window === "undefined" || !localStorage.getItem("marketingConsentAccepted")
}

export function initAnalytics(): void {
  if (ignoreAnalytics()) {
    return
  }

  if (!analyticsInitialized) {
    TagManager.initialize(tagManagerArgs)
    window.dataLayer.push({ event: "optimize.activate" })
    amplitude.init(import.meta.env.PUBLIC_AMPLITUDE_CODE, {
      serverZone: amplitude.Types.ServerZone.EU,
    })
    analyticsInitialized = true
  }
}

export function trackPageView(): void {
  if (ignoreAnalytics()) {
    return
  }

  window.dataLayer.push({ event: "page_view" })
}

export function analyticsTrackEvent(
  category: string,
  options: {
    action: string
    label?: string
    eventValue?: number
    facebookEvent?: string
    currency?: string
    contents?: any[]
    variation?: string
    authorName?: string
  }
): void {
  if (ignoreAnalytics()) {
    return
  }

  try {
    ;(window as any).dataLayer.push({ event: options.action, category: category, ...options })
    const userToken = get("_ga")
    amplitude.track(options.action, options, { user_id: userToken ?? undefined })
  } catch (_) {
    // Will error with some ad blockers, we can ignore this error
  }
}
